import { render, staticRenderFns } from "./TheContainer.vue?vue&type=template&id=4874920a&scoped=true&"
import script from "./TheContainer.vue?vue&type=script&lang=js&"
export * from "./TheContainer.vue?vue&type=script&lang=js&"
import style0 from "./TheContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TheContainer.vue?vue&type=style&index=1&id=4874920a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874920a",
  null
  
)

export default component.exports